/**
 * Absolute URL of the page the user is currently on with `params` applied: a
 * string sets the key, `null` removes it. The rest of the query string is
 * carried along, so a link copied from `/settings/workflows?tab=active` keeps
 * the tab.
 */
export const buildEntryUrl = (
  params: Record<string, string | null>,
  {
    origin,
    pathname,
    search,
  }: Pick<Location, "origin" | "pathname" | "search"> = window.location,
): string => {
  const searchParams = new URLSearchParams(search);

  Object.entries(params).forEach(([key, value]) => {
    if (value === null) {
      searchParams.delete(key);
    } else {
      searchParams.set(key, value);
    }
  });

  return `${origin}${pathname}?${searchParams.toString()}`;
};
